import React from 'react'
import { useQuery, useMutation } from '@apollo/client'
import { Redirect } from 'react-router-dom'
import Layout from '../../Layout'
import Loading from '../../Loading'
import Error from '../../Error'
import EditHeader from '../../Edit/Header'
import Form from '../Form'
import normalize from '../lib/normalize'
import DeleteHistoryAction from './DeleteHistoryAction'
import query from './lib/query'
import mutation from './lib/mutation'
import initialValues from './lib/initialValues'

export default ({
  match: {
    params: { id },
  },
}) => {
  const { loading, error, data } = useQuery(query, {
    variables: {
      id,
    },
  })

  const [mutate, mutationProps] = useMutation(mutation)
  const [photoImageUrlMutate, photoImageUrlMutationProps] = useMutation(
    mutation,
    {
      variables: {
        id,
      },
    }
  )

  if (loading) return <Loading />
  if (error) return <Error />

  return (
    <Layout>
      <EditHeader>Edit sensor</EditHeader>

      <Form
        initialValues={initialValues(data.sensor)}
        onSubmit={(data) => mutate({ variables: normalize({ id, data }) })}
        loading={mutationProps.loading}
        photoImageUrlMutate={photoImageUrlMutate}
        photoImageUrlMutationProps={photoImageUrlMutationProps}
      >
        <DeleteHistoryAction sensor={data.sensor} />
      </Form>
      {mutationProps.error && <Error leftAligned />}
      {mutationProps.data && <Redirect to='/sensors' />}
    </Layout>
  )
}
